import { render, staticRenderFns } from "./TripCost.vue?vue&type=template&id=0b22c334&"
import script from "./TripCost.vue?vue&type=script&lang=js&"
export * from "./TripCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports